// src/components/common/Toast/Toast.js
import React, { useEffect } from 'react';

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000); // 5 segundos

    return () => {
      clearTimeout(timer);
    };
  }, [onClose]);

  return (
    <div className={`toast toast-${type}`} role="alert" aria-live="assertive">
      <span>{message}</span>
      <button onClick={onClose} className="toast-close-btn" aria-label="Fechar">
        &times;
      </button>
    </div>
  );
};

export default Toast;